function StepperProgressBar3Items () {
    return <svg width="544" height="16" viewBox="0 0 544 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 8L264 8.00002" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
    <path d="M270 14L274.667 8.16667L270 2.33333" stroke="#AAAAAA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M280 8L543 8.00002" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
    </svg>
}

export default StepperProgressBar3Items;

